var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmsEventIcon = function SvgSmsEventIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h7A1.5 1.5 0 0 1 12 4.5v4a1.5 1.5 0 0 1-1.5 1.5H6.4l-1.744 1.453A.4.4 0 0 1 4 11.146V10h-.5A1.5 1.5 0 0 1 2 8.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.003 11.497 7 11.5v1A1.5 1.5 0 0 0 8.5 14h3.1l1.744 1.453a.4.4 0 0 0 .656-.307V14h.5a1.5 1.5 0 0 0 1.5-1.5v-4A1.5 1.5 0 0 0 14.5 7h-.998v1.497a3 3 0 0 1-3 3z"
  })));
};
export default SvgSmsEventIcon;